export enum AnalyticsHubFeedScreens {
  HiddenAlerts = 'HiddenAlerts',
  HubFeed = 'HubFeed',
}
